export enum BasketOrderType {
  Now = 'now',
  Future = 'future',
  Mixed = 'mixed',
  None = 'none',
}
